import { useNavigate } from 'react-router-dom';

export function useRouter() {
    const navigate = useNavigate();
    return {
        navigate,
        history: {
            goBack: () => navigate(-1),
            push: (path) => navigate(path),
            replace: (path) => navigate(path, { replace: true }),
        }
    };
}